import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';
import { GroupType } from '../models/group.model';
import { SchoolMemberType } from '../models/member.school.model';
import { MembershipStatus, MemberType } from '../models/membership.status';
import { AppState } from '../state/appstate';
import * as groupsSelector from '../state/selectors/group.selector';

export const schoolAccessGuard: CanActivateFn = (route, state) => {
  const store: Store<AppState> = inject(Store<AppState>);
  const router = inject(Router);

  const expectedRoles: string[] | undefined = route.data['roles'] as string[];

  let groupId = route.paramMap.get('id');
  if (!groupId) {
    let parent = route.parent;
    while (parent) {
      groupId = parent.paramMap.get('id');
      if (groupId) break;
      parent = parent.parent;
    }
  }

  if (!groupId) {
    router.navigate(['/groups']);
    return false;
  }
  return store.select(groupsSelector.getGroupById(groupId)).pipe(
    take(1),
    map((group) => {
      if (group?.memberStatus !== MembershipStatus.active) {
        if (group?.groupType === GroupType.church) {
          router.navigate(['groups', groupId]);
        } else {
          router.navigate(['school', groupId, 'details']);
        }
        return false;
      } else {
        // console.log(`School Route Guard: Member Roles: ${group?.memberType}`);
        // console.log(`School Route Guard:Allowed Roles: ${expectedRoles}`);
        if (group?.groupType === GroupType.church) {
          if ((group.memberType as MemberType[]).includes(MemberType.admin)) {
            return true;
          } else {
            router.navigate(['groups', groupId]);
            return false;
          }
        }

        if (
          (group.memberType as SchoolMemberType[]).some((role) =>
            expectedRoles?.includes(role)
          )
        ) {
          // console.log('School Route Guard: Allowed');
          return true;
        } else {
          // console.log('School Route Guard: Not Allowed');
          router.navigate(['school', groupId, 'details']);
          return false;
        }
      }
    })
  );
};
